export enum Alerts {
  REJECT_REASON = 'Are you sure to delete this reject reason?',
}
